import { render, staticRenderFns } from "./ServicePredictList.vue?vue&type=template&id=27fe9e87&scoped=true&"
import script from "./ServicePredictList.vue?vue&type=script&lang=js&"
export * from "./ServicePredictList.vue?vue&type=script&lang=js&"
import style0 from "./ServicePredictList.vue?vue&type=style&index=0&id=27fe9e87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe9e87",
  null
  
)

export default component.exports